(function () {
      const STORAGE_KEY  = 'cc_giftwrap';
      const checkbox     = document.getElementById('cc-giftwrap-checkbox');
      const giftwrapVariantId = checkbox ? parseInt(checkbox.dataset.giftwrapVariantId, 10) : null;

      if (!checkbox || !giftwrapVariantId) return;

      // ── Storage helpers ───────────────────────────────────────────────────
      function readStorage() {
        try { return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}'); }
        catch { return {}; }
      }

      function writeStorage(patch) {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(
          Object.assign(readStorage(), patch)
        ));
      }

      // ── Cart drawer refresh ───────────────────────────────────────────────
      function refreshCartDrawer() {
        if (window.cart && typeof window.cart.getCart === 'function') {
          window.cart.getCart().then(openDrawer).catch(openDrawer);
          openDrawer();
        } else if (document.querySelector('cart-drawer, [data-cart-drawer]')) {
          document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('theme:product:add', { bubbles: true }));
        } else {
          window.location.href = '/cart';
        }
      }

      function openDrawer() {
        document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
      }

      // ── Disable checkbox during async operations ──────────────────────────
      function setLoading(state) {
        checkbox.disabled = state;
        checkbox.closest('.cc-giftwrap').classList.toggle('cc-giftwrap--loading', state);
      }

      // ── Check if gift wrap is already in the cart ─────────────────────────
      async function getCartLineKey() {
        const res  = await fetch('/cart.js');
        const cart = await res.json();
        const line = cart.items.find(function (item) {
          return item.variant_id === giftwrapVariantId;
        });
        return line ? line.key : null;
      }

      // ── Add gift wrap to cart ─────────────────────────────────────────────
      async function addGiftwrap() {
        const res = await fetch('/cart/add.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body:    JSON.stringify({ items: [{ id: giftwrapVariantId, quantity: 1 }] })
        });
        if (!res.ok) throw new Error('Add failed');
        writeStorage({ inCart: true });
      }

      // ── Remove gift wrap from cart ────────────────────────────────────────
      async function removeGiftwrap() {
        const key = await getCartLineKey();
        if (!key) return; // already gone

        const res = await fetch('/cart/change.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body:    JSON.stringify({ id: key, quantity: 0 })
        });
        if (!res.ok) throw new Error('Remove failed');
        writeStorage({ inCart: false });
      }

      // ── Checkbox change handler ───────────────────────────────────────────
      checkbox.addEventListener('change', async function () {
        const adding = this.checked;
        setLoading(true);

        try {
          if (adding) {
            await addGiftwrap();
          } else {
            await removeGiftwrap();
          }
          refreshCartDrawer();
        } catch (err) {
          console.error('[CC Gift Wrap]', err);
          // Revert checkbox on failure
          this.checked = !adding;
        } finally {
          setLoading(false);
        }
      });

      // ── Restore checkbox state from sessionStorage on page load ───────────
      (async function init() {
        const saved = readStorage();
        if (!saved.inCart) return;

        // Verify it's actually still in the cart before restoring tick
        const key = await getCartLineKey();
        checkbox.checked = !!key;
        if (!key) writeStorage({ inCart: false });
      })();

    })();